"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFilterDisplayForms = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var displayFormResolver_1 = require("./displayFormResolver");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * This generator function resolves display form metadata objects for all attribute filters in the provided `filters`
 * parameter. The resolver will first check in-memory `displayForms` mapping; if some used display forms are not
 * found, it will consult the backend.
 *
 * @param ctx - dashboard context where the resolution is being done
 * @param filters - list of dashboard filters; resolver will extract just the attribute filters from here
 * @param displayForms - in-memory mapping of known display forms to use during the initial lookup; if not specified, the
 *  code will obtain all catalog display forms; note: this parameter is really only useful during the dashboard initialization
 *  where the catalog is not yet set. once the dashboard is initialized, the parameter is not needed
 */
function resolveFilterDisplayForms(ctx, filters, displayForms) {
    var displayFormRefs, resolvedDisplayForms;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                displayFormRefs = filters
                    .filter(sdk_model_1.isDashboardAttributeFilter)
                    .map(function (filter) { return filter.attributeFilter.displayForm; });
                return [4 /*yield*/, effects_1.call(displayFormResolver_1.resolveDisplayFormMetadata, ctx, displayFormRefs, displayForms)];
            case 1:
                resolvedDisplayForms = _a.sent();
                // TODO: this is too strict; instead of exploding, the resolver should communicate that some filters are invalid so
                //  that the upstream code can remove the filter from the filter context
                ts_invariant_1.default(isEmpty_1.default(resolvedDisplayForms.missing), "Unable to resolve display forms used in filter context filters: " + resolvedDisplayForms.missing
                    .map(function (m) { return sdk_model_1.objRefToString(m); })
                    .join(", ") + ".");
                return [2 /*return*/, Array.from(resolvedDisplayForms.resolved.values())];
        }
    });
}
exports.resolveFilterDisplayForms = resolveFilterDisplayForms;
//# sourceMappingURL=filterResolver.js.map